/**
 * Build a Tiptap-compatible ProseMirror JSON document from plain textarea
 * content. Slice 6 uses this to fill `richTextJson` for the temporary
 * `<textarea>` body editor; Slice 9 reads the same shape directly to seed the
 * Yjs document state, so no migration is required (Adjustments Log #15).
 *
 * Shape mirrors Tiptap's default schema: one `paragraph` node per `\n`-separated
 * line. Non-empty lines hold a single `text` node; empty lines render as a
 * paragraph with no `content` array (Tiptap's empty-paragraph form). CRLF input
 * is normalized to LF before splitting.
 */
interface TiptapTextNode {
  readonly type: 'text';
  readonly text: string;
}

interface TiptapParagraphNode {
  readonly type: 'paragraph';
  readonly content?: readonly TiptapTextNode[];
}

export interface TiptapDoc {
  readonly type: 'doc';
  readonly content: readonly TiptapParagraphNode[];
}

export function plainTextToTiptapDoc(text: string): TiptapDoc {
  const normalized = text.replace(/\r\n/g, '\n');
  const lines = normalized.split('\n');
  const paragraphs: TiptapParagraphNode[] = lines.map(line =>
    line.length === 0
      ? { type: 'paragraph' }
      : { type: 'paragraph', content: [{ type: 'text', text: line }] }
  );
  return { type: 'doc', content: paragraphs };
}
